import { msg } from 'gt-react';
import { GraphIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const SupplyNetworkPage = lazyRouteComponent(
  () => import('./SupplyNetworkPage'),
  'SupplyNetworkPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/inventory-management/supply-network',
  staticData: {
    app: {
      nav: {
        label: msg('Supply Network', {
          context: 'sidebar nav label, Inventory Management section',
        }),
        icon: <GraphIcon className="h-4 w-4" weight="fill" />,
        group: 'Inventory Management',
        order: 15,
        groupOrder: 25,
      },
      access: {
        modulesAnyOf: [ProductModule.INVENTORY_MANAGEMENT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SupplyNetwork },
        ],
      },
    },
  },
  component: SupplyNetworkPage,
  loader: () => ({
    crumb: msg('Supply Network', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.INVENTORY_MANAGEMENT],
    });
    // The nav entry hides without the permission; this keeps the URL closed
    // too.
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SupplyNetwork,
    });
  },
});
